/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.WorkActivities {
    import WorkActivity = Meevo.Model.WorkActivity;
    "use strict";

    export class WorkActivitiesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            $scope: angular.IScope) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            //this.baseEndpoint = appSettings.API_ENDPOINTS.blockType + '/' + this.selectedSection.model.id + '/Locations';
            this.baseEndpoint = appSettings.API_ENDPOINTS.workActivity;
            this.sectionTemplatePath = "app/plugins/workActivities/sectionViews/";

            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            this.buildCrudSecurityKeys(this.securityKeys.DATA_WORKACTIVITY_TAB_MAIN);
            this.entityType = 'WorkActivity';

        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_WORKACTIVITY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_WORKACTIVITIES_MAIN",
                    "main.html",
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.workActivity,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService, 
                    Meevo.Model.NounEnum.WorkActivityMain,
                    this.modalService,
                    this.securityKeys.DATA_WORKACTIVITY_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ ));
         }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }


        canSelectShowOnAppointmentBook(model: WorkActivity): boolean {
            if (model === undefined || model === null)
                return false;

            if (this.isReadonly || !this.isAccessible || model.isBookableTime)
                return false;
            return true;

        }
        
        get toggleWorktime(): boolean {
            if (this.selectedSection.model === null || this.selectedSection.model === undefined)
                return false;
            return (<WorkActivity>this.selectedSection.model).isBookableTime;
        }
        set toggleWorktime(value: boolean) {

            if (this.selectedSection.model !== null && this.selectedSection.model !== undefined){

                if (value) {                    
                    (<WorkActivity>this.selectedSection.model).showOnBook = true;
                }
                (<WorkActivity>this.selectedSection.model).isBookableTime = value;             
            }
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.WorkActivity>();
            model.displayName = undefined;
        }
        
    }
}